import userApi from '@/api/ks/user'

const user = {
  state: {
    id: null,
    name: '',
    changePwd: false, //true: 强制修改密码
    // unitName: '',
    dataRange: 0,
    unauthorized: false,
  },
  getters: {
    hasIdentityInfo: state => {
      return state.id != null
    },
    isLogin: state => {
      // return sessionStorage.getItem("token") ? true : false
      return localStorage.getItem("token") ? true : false
    }
  },
  mutations: {
    SET_ID(state, id) {
      state.id = id
    },
    SET_NAME(state, name) {
      state.name = name
    },
    SET_CHANGEPWD(state, changePwd) {
      state.changePwd = changePwd
    },
    // SET_UNITNAME(state, unitName) {
    //   state.unitName = unitName;
    // },
    SET_DATA_RANGE(state, dataRange) {
      state.dataRange = dataRange
    },
    SET_UNAUTHORIZED(state, unauthorized) {
      state.unauthorized = unauthorized
    }
  },
  actions: {
    setChangePwd({ commit }, changePwd) {
      commit('SET_CHANGEPWD', changePwd)
    },
    setUnauthorized({ commit }, unauthorized) {
      commit('SET_UNAUTHORIZED', unauthorized)
    },
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        userApi.login(user).then(res => {
          // console.log(res)
          if (res.errorCode) {
            reject(res);
          } else {
            localStorage.setItem("token", res.accessToken);
            localStorage.setItem("user-info", JSON.stringify({
              mallId: res.mallId,
              mallName: res.mallName,
              userId: res.userId,
              userName: res.userName,
              refreshToken: res.refreshToken,
            }));
            resolve(res);
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    loginByMobile({ commit, dispatch }, user) {
      return new Promise((resolve, reject) => {
        userApi.loginByMobile(user).then(res => {
          if (res.Code == 0) {
            // sessionStorage.setItem("token", res.Data.Token);
            localStorage.setItem("token", res.Data.Token);
            localStorage.setItem("refresh", res.Data.RefreshToken);
            let loginInfo = {
              UserId: res.Data.Id,
              UserName: res.Data.Name,
              ChangePwd: false,
              // ChangePwd: res.Data.ChangePwd,
              // UnitName: res.Data.UnitName
            }
            localStorage.setItem("loginInfo", JSON.stringify(loginInfo));
            // dispatch("getIdentityInfo");
            // sessionStorage.setItem("loginInfo", JSON.stringify(loginInfo));
            resolve(res);
          } else {
            reject(res);
          }
        })
      })
    },
    getIdentityInfo({ commit, dispatch }) {
      return new Promise((resolve, reject) => {

        var loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
        commit('SET_ID', loginInfo.UserId)
        commit('SET_NAME', loginInfo.UserName)
        commit('SET_CHANGEPWD', loginInfo.ChangePwd)
        // commit('SET_UNITNAME', loginInfo.UnitName)

        userApi.getPermission().then(res => {
          if (res.Data != null) {
            let dataRange = res.Data.Roles.some(item => item.DataRange == 1)
            commit('SET_DATA_RANGE', dataRange)
            function buildPermissionAndFullPath(menu) {
              res.Data.Menus.forEach((m, i) => {
                if (m.Pid == menu.MenuId) {
                  m.FullPath = menu.FullPath + '/' + m.Url;
                  m.PermissionPath = (menu.PermissionPath ? (menu.PermissionPath + '.') : "") + m.Url;
                  buildPermissionAndFullPath(m);
                }
              })
            }
            buildPermissionAndFullPath({
              MenuId: 0,
              FullPath: "",
              PermissionPath: ""
            });
            commit("SET_PERMISSION_MENUS", res.Data.Menus, { root: true });
            resolve(res.Data)
          }
        }).catch(error => {
          dispatch('logout')
          reject(error)
        })
      })
    },
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        commit('SET_ID', null)
        resolve({})
        // userApi.logout().then(res => {
        //   commit('SET_ID', null)
        //   resolve(res.Data)
        // })
      })
    },
    refreshToken({ commit }) {
      return new Promise((resolve, reject) => {
        let data = {
          Token: localStorage.getItem("token"),
          RefreshToken: localStorage.getItem("refresh")
        }
        // console.log('rdata', data)
        userApi.refreshToken(data).then(res => {
          // console.log('refreshToken', res)
          if (res.Code == 0 && res.Data != null) {
            localStorage.setItem("token", res.Data.Token);
            localStorage.setItem("refresh", res.Data.RefreshToken);
            // sessionStorage.setItem("token", res.Data.Token);
            // sessionStorage.setItem("refresh", res.Data.RefreshToken);
          }
          resolve(res)
        })
      })
    },
    clearStorage({ commit }) {
      localStorage.clear();
      // localStorage.removeItem("token");
      // localStorage.removeItem("refresh");
      // localStorage.removeItem("loginInfo")
      // window.location.href = window.location.origin + '/#/register';
      // window.location.reload();
    },
  }
}
export default user
